module.exports = __webpack_public_path__ + "static/media/plantTwo.6662c7b0.jpg";